module.exports = __webpack_public_path__ + "static/img/mood6.63666d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moods/mood6.png
// module id = G33G
// module chunks = 1